import React from 'react';
import classnames from 'classnames';

import Image from 'components/Image';
import { Props } from './types';

const QualityRequirement = (props: Props) => {
  const {
    data,
    tooltipPos,
    storylet,
    type,
  } = props;

  const {
    availableAtMessage,
    description,
    image,
    nature,
    status,
    tooltip,
  } = data;

  const qreqClass = classnames({
    icon: true,
    'icon--circular': nature === 'Status',
    'icon--locked': status === 'Locked',
    'icon--purchase': type === 'purchase',
    'quality-requirement': true,
    'quality-requirement--storylet': storylet,
  });

  const tooltipData = {
    ...data,
    description: tooltip || description,
  };

  return (
    <div className={qreqClass}>
      <Image
        icon={image}
        alt={availableAtMessage}
        type="small-icon"
        tooltipData={tooltipData}
        tooltipPos={tooltipPos}
        defaultCursor
      />
    </div>
  );
};

export default QualityRequirement;
